<script>
  /* Executable code section of the program */
  //Tool importation
  import {
    isOnetoOneMeetingsOn,
    temporalAttendee,
    userLocalData,
    invitedAttendeesArray,
    breakInfo,
    userRealTime,
    isAlertOn,
    alertMessagge,
    isReloadNecessary,
    noSlotsModalOn
  } from "../../apis/storage";
  import {
    getSpecificDocuments,
    idGenerator,
    updateMultipleDocuments,
    createDocumentWithID,
    getOneDocument,
  } from "../../apis/APIS";
  import { sendInvitationEmail } from "../../apis/apisSendEmail";
  import { onMount } from "svelte";

  //Components importation
  import BreakOnetoOneCard from "../Cards/BreakOnetoOneCard.svelte";
  import SelectAttendees from "../SelectAttendees.svelte";
  import NoSlotsModal from "./NoSlotsModal.svelte";

  //Auxiliary variables
  let event = [];
  let networkingBreaks = [];
  let arrayInvitations = [];
  $: dinamicInvitesAttendees = $invitedAttendeesArray;
  let objData = {};
  let meetingsOn;
  let tableVariables = false;
  let currentMeeting = [];

  //Variables necessary for pagination and filters
  let eventUser = "";

  //Function to undisplay modal
  const undisplayModal = () => {
    $isOnetoOneMeetingsOn = false;
    $breakInfo.typeBreak = "";
    $breakInfo = {};
  };

  //Function to display modal alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  //Custom authorization verification
  const customVerification = (array, id) => {
    if (array !== undefined) {
      return array.includes(id);
    }
  };

  // Reactive assignment
  $: dinamicMeetingCustom = $breakInfo ?? {};

  // Reactive conditional
  $: {
    if (dinamicMeetingCustom && Object.keys(dinamicMeetingCustom).length > 0) {
      searchMeet();
    }
  }
  const searchMeet = async () => {
    currentMeeting = await getSpecificDocuments(
      "meetings",
      "breakId",
      $breakInfo.id
    );
  };
  //Function to verify the time of breaks and local time
  const convertTimeToDateObject = (endTime) => {
    let localTime = new Date().toLocaleTimeString();

    //Getting hours in numerical form
    const [hoursLocal, minutesLocal] = localTime.split(":").map(Number);
    const [hoursEndTime, minutesEndTime] = endTime.split(":").map(Number);

    //Conversion of elapsed time
    let localTotalTime = hoursLocal * 60 + minutesLocal;
    let endTotalTime = hoursEndTime * 60 + minutesEndTime;

    //Conditional verificator
    if (localTotalTime < endTotalTime - 10) {
      return true;
    } else {
      return false;
    }
  };

  //Function to schedul a meeting
  const schedulMeetings = async () => {
    /* Condicional para verificar si ya hay un break seleccionado */
    let fallbackEndTime;
    let falbackFinalTime;
    let endSchedulTime = 0;
    let endFinalTime = 0;

    /* Seccion para verificar si se tiene o seleccionado un break */
    if (Object.keys($breakInfo).length === 0) {
      $alertMessagge =
        "You must select a networking break to send the invitation.";
      displayAlert();
      return;
    }
    /* Dessarrollo del codigo */

    /* Seccion para saber las mesas y el timepo de los breaks seleccionados */
    let realTimeBreak = await getOneDocument("breaks", $breakInfo.id);
    
    if ($breakInfo.typeBreak === "Regular") {
      fallbackEndTime = realTimeBreak.scheduledMeetings.meetingTime.endTime;
      falbackFinalTime = realTimeBreak.endTime;
      let [endHour, endMinutes] = fallbackEndTime.split(":").map(Number);
      let [endFinaltHour, endFinalMinutes] = falbackFinalTime
        .split(":")
        .map(Number);

      endSchedulTime = endHour * 60 + endMinutes;
      endFinalTime = endFinaltHour * 60 + endFinalMinutes;
      console.log(endSchedulTime,endFinalTime);

    /*   tableVariables =
        parseInt(realTimeBreak.scheduledMeetings.meetingTable) >=
        parseInt(realTimeBreak.totalTables); */
    }
    
    console.log($breakInfo);
    
    /* Seccion para verificar si es posible agendar un meet */
    if (
      $breakInfo.typeBreak === "Regular" &&
      (endSchedulTime >= endFinalTime)
    ) {
      $noSlotsModalOn = true
      return;
    } else {
      /* Seccion para crear el meet */
      let breakData = {};
      let usersData = [];
      
      //Break information designation
      breakData.id = idGenerator();
      breakData.breakTittle = $breakInfo.breakTittle;
      breakData.meetStatus = "pending";
      breakData.breakId = $breakInfo.id;
      breakData.placeBreak = $breakInfo.placeBreak;
      breakData.totalTables = event[0].tablesNumber;
      breakData.event = event[0].tittle;
      breakData.meetType = $breakInfo.typeBreak;
      breakData.meetingTable = 1;
      breakData.slotTime = $breakInfo.slotTime;
      breakData.meetingTime = {
        startTime: $breakInfo.startTime,
        endTime: $breakInfo.endTime,
      };
      if ($breakInfo.typeBreak === "Regular") {
        breakData.meetingCustomTable =
          $userRealTime.customTables?.length > 0
            ? $userRealTime.customTables[0].tableName
            : "";
      }
      
      if ($breakInfo.typeBreak === "Custom") {
        if (currentMeeting.length > 0) {
        breakData.limitAttendees = currentMeeting.length > 0
            ? currentMeeting[0].limitAttendees
            : parseInt($breakInfo.limitAttendees);
        breakData.acceptedAttendees = currentMeeting[0].acceptedAttendees.length > 0
            ? currentMeeting[0].acceptedAttendees
            : [];
        breakData.declinedAttendees = currentMeeting[0].declinedAttendees.length > 0
            ? currentMeeting[0].declinedAttendees
            : [];
        } else {
          breakData.limitAttendees = parseInt($breakInfo.limitAttendees);
          breakData.acceptedAttendees = [];
          breakData.declinedAttendees = [];
        }
      }
      breakData.host = {
        name: $userRealTime.name,
        surname: $userRealTime.surname,
        country: $userRealTime.country,
        jobtittle: $userRealTime.jobtittle,
        company: $userRealTime.company,
        email: $userRealTime.email,
        profileImgUrl: $userRealTime.profileImgUrl,
        id: $userRealTime.id,
      };
      if ($breakInfo.typeBreak === "Regular") {
        breakData.invitedAttendees = $invitedAttendeesArray
      } else {
        breakData.invitedAttendees = currentMeeting.length > 0 ?[
              ...(currentMeeting[0].invitedAttendees || []),
              ...$invitedAttendeesArray,
            ]
            : []
      }

      if ($breakInfo.typeBreak === "Regular") {
        //Function section
        $invitedAttendeesArray.forEach((element) => {
          usersData.push({
            id: element.id,
            fieldName: "scheduledMeetings",
            values: [breakData.id],
          });
        });
        usersData.push({
          id: $userRealTime.id,
          fieldName: "scheduledMeetings",
          values: [breakData.id],
        });
      } else {
        //Function section
        $invitedAttendeesArray.forEach((element) => {
          usersData.push({
            id: element.id,
            fieldName: "scheduledMeetings",
            values: [$breakInfo.id],
          });
        });
        usersData.push({
          id: $userRealTime.id,
          fieldName: "scheduledMeetings",
          values: [$breakInfo.id],
        });
      }
      updateMultipleDocuments("users", usersData)
        .then(() => {
          /* 
          createDocumentWithID("meetings", breakData.id, breakData)
            .then(() => {
              if ($breakInfo.typeBreak === "Regular") {
                $invitedAttendeesArray.forEach((element) => {
                  sendInvitationEmail(
                    element.email,
                    "meet",
                    element,
                    breakData.host
                  ).then(() => {
                    $alertMessagge =
                      "Meet invitation successfully sent to the attendee.";
                    $isReloadNecessary = true;
                    $isOnetoOneMeetingsOn = false;
                    displayAlert();
                  });
                });
              } else {
                $invitedAttendeesArray.forEach((element) => {
                  sendInvitationEmail(
                    element.email,
                    "meet",
                    element,
                    breakData.host
                  );
                });
                $alertMessagge = `Meet invitation sent to all attendees`;
                $isReloadNecessary = true; 
                displayAlert();
              }
            })
            .catch(() => {
              $alertMessagge =
                "An error occurred while creating the meet invitations";
              displayAlert();
            }); */
          if ($breakInfo.typeBreak === "Regular") {
            createDocumentWithID("meetings", breakData.id, breakData)
              .then(() => {
                $invitedAttendeesArray.forEach((element) => {
                  sendInvitationEmail(
                    element.email,
                    "meet",
                    element,
                    breakData.host,
                    window.location.pathname.split("/")[2]
                  ).then(() => {
                    $alertMessagge =
                      "Meeting invitation successfully sent to the attendee.";
                    /* $isReloadNecessary = true; */
                    $isOnetoOneMeetingsOn = false;
                    displayAlert();
                  });
                });
              })
              .catch(() => {
                $alertMessagge =
                  "An error occurred while creating the meet invitations";
                displayAlert();
              });
          } else {
            createDocumentWithID("meetings", $breakInfo.id, breakData)
              .then(() => {
                $invitedAttendeesArray.forEach((element) => {
                  sendInvitationEmail(
                    element.email,
                    "meet",
                    element,
                    breakData.host,
                    window.location.pathname.split("/")[2]
                  );
                });
                $alertMessagge = `Meeting invitation sent to all attendees`;
                /* $isReloadNecessary = true; */
                displayAlert();
                $isOnetoOneMeetingsOn = false
              })
              .catch(() => {
                $alertMessagge =
                  "An error occurred while creating the meet invitations";
                displayAlert();
              });
          }
        })
        .catch(() => {
          $alertMessagge =
            "An error occurred while sending the meet invitations";
          displayAlert();
        });
    } 
  };

  onMount(async () => {
    event = await getSpecificDocuments(
      "events",
      "tittle",
      $temporalAttendee.event
    );

    networkingBreaks = event[0].networkingBreaks;

    $invitedAttendeesArray = [];

    //Save principal attendee
    let attendee = {};

    attendee.name = $temporalAttendee.name;
    attendee.surname = $temporalAttendee.surname;
    attendee.country = $temporalAttendee.country;
    attendee.company =
      $temporalAttendee.company || $temporalAttendee.department;
    attendee.jobtittle = $temporalAttendee.jobtittle;
    attendee.email = $temporalAttendee.email;
    attendee.profileImgUrl = $temporalAttendee.profileImgUrl;
    attendee.id = $temporalAttendee.id;

    $invitedAttendeesArray.push(attendee);
    dinamicInvitesAttendees = $invitedAttendeesArray;
    eventUser = $userLocalData[0].event;
    let meetingsButton = event[0].eventButtons.filter(
      (element) => element.buttonTittle === "Meetings"
    );
    meetingsOn = meetingsButton[0].isAvailable;
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="modalContainer">
  <div class="oneToOneContainer">
    <div class="headerMeet">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={() => undisplayModal()}
        on:click={() => undisplayModal()}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    {#if meetingsOn}
      <div class="bodyMeet">
        <div class="headerContent">
          <h4>Schedule Break Meeting</h4>
        </div>
        <div class="bodyContentBreaks">
          {#if Object.keys($breakInfo).length < 1 || $breakInfo.typeBreak !== "Custom"}
            {#each networkingBreaks as networking}
              {#each networking.programmedBreaks as programmedBreak}
                {#if programmedBreak.isVisibleBreak}
                  {#if convertTimeToDateObject(programmedBreak.endTime) || $userLocalData.userRole !== "attendee"}
                    {#if programmedBreak.typeBreak !== "Regular"}
                      {#if customVerification($userRealTime.customBreaks, programmedBreak.id) || $userLocalData[0].userRole !== "attendee"}
                        <BreakOnetoOneCard {programmedBreak} {networking} />
                      {/if}
                    {:else}
                      <BreakOnetoOneCard {programmedBreak} {networking} />
                    {/if}
                  {/if}
                {/if}
              {/each}
            {/each}
          {:else}
            <SelectAttendees {eventUser} />
          {/if}
        </div>
      </div>
      <div class="footerMeet">
        {#if Object.keys($breakInfo).length > 0 && $breakInfo.typeBreak === "Custom"}
          <button
            class="actionBtn addEventBtn"
            on:click={() => {
              $breakInfo = {};
            }}>Back</button
          >
        {/if}
        <button class="actionBtn addEventBtn" on:click={() => schedulMeetings()}
          >Schedule Meeting</button
        >
      </div>
    {:else}
      <div class="meetingsOff">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="50"
          fill="currentColor"
          class="bi bi-card-checklist"
          viewBox="0 0 16 16"
        >
          <path
            d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"
          />
          <path
            d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0"
          />
        </svg>
        <p>
          Meetings are currently disabled. Please wait for a coordinator to
          enable them before scheduling one.
        </p>
      </div>
    {/if}
  </div>
</section>
{#if $noSlotsModalOn}
  <NoSlotsModal/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .modalContainer {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: auto;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.432);
    padding: 30px;
    display: flex;
    justify-content: center;
  }
  .oneToOneContainer {
    background-color: white;
    width: 70%;
    height: auto;
    max-height: 90dvh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 20px;
  }
  /* End section */
  /* Header styles */
  .headerMeet {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    padding: 20px 30px;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  /* End Section */
  .bodyMeet {
    width: 90%;
    padding: 10px 30px;
  }
  .headerContent {
    border-bottom: 1px solid gray;
  }
  .bodyContentBreaks {
    background-color: #f4f4f4;
    padding: 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  /* Finals Buttons styles */
  .footerMeet {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    padding: 10px 30px;
  }
  .actionBtn {
    width: 200px;
    height: 50px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 5px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* Meetings off */
  .meetingsOff {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 90%;
    height: 100%;
    background-color: #f4f4f4;
  }
  /* End Section */
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    /* Principal styles */
    .modalContainer {
      width: 100%;
      height: auto;
    }

    .oneToOneContainer {
      height: 70%;
      max-height: 90dvh;
      overflow: auto;
    }
    /* Filter buttons */
    .actionBtn {
      margin: 10px;
    }
    /* Final Buttons */
    .footerMeet {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 10px 30px;
    }
    /* End section */
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .modalContainer {
      position: fixed;
      top: 0;
      z-index: 999;
      width: 100%;
      height: auto;
      min-height: 100vh;
      padding: 10px;
    }

    .oneToOneContainer {
      width: 100%;
      max-height: 90dvh;
      overflow: auto;
    }
    /* Header styles */
    .headerMeet {
      width: 90%;
      display: flex;
      justify-content: flex-end;
      padding: 20px 30px;
    }
    /* End Section */
    .bodyMeet {
      width: 100%;
      padding: 10px;
    }

    /* End section */
    /* Finals Buttons styles */
    .footerMeet {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 30px;
    }
    .actionBtn {
      width: 200px;
      height: auto;
      border-radius: 12px;
      font-size: 16px;
      font-weight: 500;
      padding: 8px 16px;
      background-color: white;
      color: #111;
      border: 1px solid #444;
      transition: all 0.3s ease-in-out;
      margin: 10px 0;
    }
  }

  /* End of the section */
</style>
